import { client } from "api";

export type DeleteMediaRequest = { mediaId: string };
export type DeleteMediaResponse = string;

export const deleteMedia = ({ mediaId }: DeleteMediaRequest) =>
  client.delete<DeleteMediaResponse>(`/bin/${mediaId}`).then((res) => res.data);
